// Maps technical Supabase / network errors to plain Turkish messages.
// Non-technical users should never see a raw error.message.

const ERROR_MAP = [
  // Network / bağlantı
  [/fetch|failed to fetch|network|ERR_NETWORK|load failed/i,
    "İnternet bağlantısı sorunu yaşandı. Bağlantınızı kontrol edip tekrar deneyin."],

  // Oturum / yetki
  [/jwt expired|token expired|session.*expired|refresh.*token/i,
    "Oturumunuz sona erdi. Lütfen sayfayı yenileyip tekrar giriş yapın."],
  [/invalid login|invalid credentials|wrong password|email not confirmed/i,
    "E-posta veya şifre hatalı."],
  [/not authorized|permission denied|row-level security|new row violates row-level/i,
    "Bu işlem için yetkiniz yok. Lütfen tekrar giriş yapıp deneyin."],

  // Veritabanı kısıtlamaları
  [/duplicate key|unique constraint|already exists/i,
    "Bu bilgi zaten kayıtlı. Lütfen farklı bir değer girin."],
  [/not-null constraint|null value in column|violates not-null/i,
    "Zorunlu bir alan boş bırakılamaz."],
  [/foreign key constraint/i,
    "İlişkili kayıt bulunamadı. Sayfayı yenileyip tekrar deneyin."],

  // Dosya yükleme
  [/file size|payload too large|too large|max.*size/i,
    "Dosya boyutu çok büyük. Lütfen daha küçük bir dosya seçin (max 50 MB)."],
  [/invalid file|file type|unsupported.*type/i,
    "Desteklenmeyen dosya türü. PNG, JPG, WebP veya MP4 kullanın."],
  [/storage|bucket/i,
    "Dosya yükleme sırasında hata oluştu. Lütfen tekrar deneyin."],

  // Şema / yapılandırma
  [/column.*does not exist|relation.*does not exist|schema.*cache/i,
    "Sistem yapılandırma hatası. Sayfayı yenileyip tekrar deneyin."],
];

export const translateError = (err) => {
  if (!err) return "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.";
  const raw = err.message || err.code || err.error_description || String(err);
  for (const [pattern, text] of ERROR_MAP) {
    if (pattern.test(raw)) return text;
  }
  return "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.";
};
